export const RELEASE_NOTES_REPORT = {
  headline: 'Drafted notes for 14 merged PRs',
  status: 'done',
  durationSec: 46,
  body: `**Drafted release notes for 14 pull requests** — saved as a draft on the *Changelog* page in Notion.

### New

- **Schedules page** — see and edit every recurring task in one place.
- **Office previews** — Word, Excel, and PowerPoint files preview inline in chat.

### Improved

- Faster recovery when the connection drops mid-answer.
- Creating a HubSpot task now confirms the record it created.

### Fixed

- Sending from Gmail no longer reports success without a delivery receipt.
- The Recent chats list shows 7 chats with a “View more” footer.

5 internal changes (tests, CI, refactors) were left out of the customer notes.`,
}
